/**
 * Created by iamso on 07.08.19.
 */

const TellWindow = CleverappsWindow.extend({
    onWindowLoaded: function (params) {
        const content = this.createText(params.text);

        this._super({
            content,
            name: "tellwindow",
            title: params.title,
            fireworks: cleverapps.environment.isBonusWorldScene(),
            button: {
                text: params.buttonText || Messages.get("OK"),
                onPressed: function () {
                    this.close();
                    if (params.onPressed) {
                        params.onPressed();
                    }
                }.bind(this)
            }
        });
    },

    getPerson: function () {
        return {
            role: "hero",
            emotion: "happy"
        };
    },

    createText: function (message) {
        const styles = cleverapps.styles.TellWindow;

        const text = cleverapps.UI.generateOnlyText(message, cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.text.width, 0);
        text.fitTo(undefined, styles.text.height);

        return text;
    },

    listBundles: function () {
        return ["tellwindow"];
    }
});

cleverapps.styles.TellWindow = {
    text: {
        width: 650,
        height: 400
    }
};
